import * as turf from '@turf/turf';

export const getFeatures = (geojson) => {
  const markerPoints = {};

  turf.featureEach(geojson, (currentFeature) =>
    turf.featureEach(currentFeature, (feature) => {
      const { properties } = feature;

      // Get markers coordinates.
      return turf.geomEach(feature, (currentGeometry) => {
        const featureType = properties.type || 'Other';
        const multiPoint = turf.getType(currentGeometry) === 'MultiPoint';
        const coordinates = turf.getCoords(currentGeometry);

        if (!Object.keys(markerPoints).includes(featureType)) {
          markerPoints[featureType] = [];
        }

        markerPoints[featureType].push({
          coordinates: multiPoint ? coordinates : [coordinates],
          properties,
        });
      });
    })
  );

  return markerPoints;
};

export function decodeHTMLEntities(text) {
  const entities = {
    amp: '&',
    apos: "'",
    '#x27': "'",
    '#x2F': '/',
    '#39': "'",
    '#47': '/',
    lt: '<',
    gt: '>',
    nbsp: ' ',
    quot: '"',
  };

  return JSON.parse(`"${text}"`).replace(
    /&([^;]+);/gm,
    (match, entity) => entities[entity] || match
  );
}
